<template>
  <div>
    <b-card no-body>
      <b-card-header>
          <h3 class="float-left"><i class='fa fa-list'></i> Gift List</h3>
          <!-- <b-button variant="primary" class="float-right" @click="showCreateModal">Create List</b-button> -->
      </b-card-header>
      <b-card-body>
        <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
          <template v-slot:cell(action)="data">
            <b-button variant="warning" @click="showEditModal(data.item.Id)">Edit</b-button>
          </template>
        </b-table>
        <nav>
          <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
        </nav>
      </b-card-body>
    </b-card>
    <!-- <b-modal ref="createGifList" size="lg" header-bg-variant="primary" hide-footer title="Create Gift List">
          <div class="d-block">
            <b-row>
              <b-col sm="12">
                <b-row>
                  <b-col sm="12">
                    <b-form-group :state="!($v.cGiftListName.$error)">
                      <label for="cGiftListName">Name</label>
                      <b-form-input type="text" id="cGiftListName" placeholder="Name" v-model="cGiftListName" :state="$v.cGiftListName.$error?false:null" @focus.native="$v.cGiftListName.$touch"></b-form-input>
                      <div v-if="$v.cGiftListName.$error">
                        <div class="invalid-feedback d-block" v-if="!$v.cGiftListName.required">Name is required</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.cGiftListName.minLength">Must have at least {{ $v.cGiftListName.$params.minLength.min}} letters</div>
                        <div class="invalid-feedback d-block" v-else-if="!$v.cGiftListName.maxLength">Must not exceed {{ $v.cGiftListName.$params.maxLength.max}} letters</div>
                      </div>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <b-btn class="mt-3" variant="primary" @click="createGiftList" :disabled="$v.cGiftListName.$invalid">Create</b-btn>
          <b-btn class="mt-3" variant="outline-danger" @click="hideCreateModal">Cancel</b-btn>
    </b-modal> -->
    <b-modal ref="editGifList" size="lg" header-bg-variant="primary" hide-footer title="Edit Gift List">
          <div class="d-block">
            <b-row>
              <b-col sm="12">
                <!-- <b-row>
                  <b-col sm="12">
                    <b-form-group :state="!($v.giftId.$error && $v.giftOccurrence.$error && $v.giftDisplayOrder.$error)">
                      <b-row>
                        <b-col sm="12">
                          <label for="giftId">Gift</label>
                          <b-form-select id="giftId" :plain="false" v-model.trim="giftId" :state="$v.giftId.$error?false:null" @blur.native="$v.giftId.$touch">
                            <option :value="null">Please select</option>
                            <option v-for="g in gifts" :value="g.Id">GiftId: {{ g.Id }}, Name: {{ g.Name }}, Qty: {{ g.Quantity }}</option>
                          </b-form-select>
                          <div v-if="$v.giftId.$error">
                            <div class="invalid-feedback d-block" v-if="!$v.giftId.required">Gift is required</div>
                          </div>
                        </b-col>
                      </b-row>
                      <b-row>
                        <b-col sm="4">
                          <label for="giftOccurrence">Occurrence</label>
                          <b-form-input type="text" id="giftOccurrence" placeholder="Enter Winning Occurrence" v-model="giftOccurrence" :state="$v.giftOccurrence.$error?false:null" @focus.native="$v.giftOccurrence.$touch"></b-form-input>
                          <div v-if="$v.giftOccurrence.$error">
                            <div class="invalid-feedback d-block" v-if="!$v.giftOccurrence.required">Winning occurrence is required</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.giftOccurrence.minValue">Must bigger than {{ $v.giftOccurrence.$params.minValue.min}}</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.giftOccurrence.maxValue">Must less than {{ $v.giftOccurrence.$params.maxValue.min}}</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.giftOccurrence.numeric">Must be numeric letters</div>
                          </div>
                        </b-col>
                        <b-col sm="4">
                          <label for="giftDisplayOrder">Display Order</label>
                          <b-form-input type="text" id="giftDisplayOrder" placeholder="Enter Display Order" v-model="giftDisplayOrder" :state="$v.giftDisplayOrder.$error?false:null" @focus.native="$v.giftDisplayOrder.$touch"></b-form-input>
                          <div v-if="$v.giftDisplayOrder.$error">
                            <div class="invalid-feedback d-block" v-if="!$v.giftDisplayOrder.required">Display order is required</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.giftDisplayOrder.minValue">Must bigger than {{ $v.giftDisplayOrder.$params.minValue.min}} letters</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.giftDisplayOrder.maxValue">Must less than {{ $v.giftDisplayOrder.$params.maxValue.max}} letters</div>
                            <div class="invalid-feedback d-block" v-else-if="!$v.giftDisplayOrder.numeric">Must be numeric letters</div>
                          </div>
                        </b-col>
                        <b-col sm="4">
                          <label for="addGiftBtn">&nbsp;</label>
                          <div>
                            <b-btn id="addGiftBtn" variant="success" @click="addGift" :disabled="($v.giftId.$invalid || $v.giftOccurrence.$invalid || $v.giftDisplayOrder.$invalid)">
                              <i class="fa fa-plus-circle"></i> Add
                            </b-btn>
                          </div>
                        </b-col>
                      </b-row>
                    </b-form-group>
                  </b-col>
                </b-row> -->
                <b-row>
                  <b-col sm="12">
                    <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="listGifts" :fields="listGiftsFields" :current-page="giftsCurrentPage" :per-page="giftsPerPage">
                      <template v-slot:cell(Occurrence)="data">
                        <template v-if="!data.item._showUpdate">{{ data.item.Occurrence }}</template>
                        <b-form-input v-else type="text" id="cOccurrence" placeholder="Occurrence" v-model="cOccurrence" :state="$v.cOccurrence.$error?false:null" @focus.native="$v.cOccurrence.$touch"></b-form-input>
                      </template>
                      <template v-slot:cell(DisplayOrder)="data">
                        <template v-if="!data.item._showUpdate">{{ data.item.DisplayOrder }}</template>
                        <b-form-input v-else type="text" id="cDisplayOrder" placeholder="DisplayOrder" v-model="cDisplayOrder" :state="$v.cDisplayOrder.$error?false:null" @focus.native="$v.cDisplayOrder.$touch"></b-form-input>
                      </template>
                      <!-- <template v-slot:cell(action)="data">
                        <template v-if="data.item._showUpdate">
                          <b-button class="btn-sm" variant="success" @click="updateGiftList(data.item)">Save</b-button>
                          <b-button class="btn-sm" variant="danger" @click="cancelUpdateGiftList(data.item)">Cancel</b-button>
                        </template>
                        <template v-else>
                          <b-button class="btn-sm" variant="warning" @click="showUpdateGiftList(data.item)">Update</b-button>
                          <b-button class="btn-sm" variant="danger" @click="confirmRemoveGift(data.item.Id)">Remove</b-button>
                        </template>
                      </template> -->
                    </b-table>
                    <nav>
                      <b-pagination :total-rows="getRowCount(listGifts)" :per-page="giftsPerPage" v-model="giftsCurrentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
                    </nav>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </div>
          <b-btn class="mt-3" variant="outline-danger" @click="hideEditModal">Cancel</b-btn>
    </b-modal>
    <!-- <b-modal ref="confirm" size="sm" centered header-bg-variant="primary" hide-footer title="Remove This Gift">
          <div class="mb-3">
            Are you sure?
          </div>
          <b-button variant="success" @click="removeGift">Yes</b-button>
          <b-button variant="outline-danger" @click="cancelRemove">Cancel</b-button>
    </b-modal> -->
  </div>
</template>

<script>
  import VueNotifications from 'vue-notifications'
  import {Events} from '../../../events.js'
  const {required, minLength, maxLength, minValue, maxValue, numeric} = require('vuelidate/lib/validators')
  export default {
    name: 'gift-list-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        items: [],
        gifts: [],
        listGifts: [],
        fields: [
          {key: 'Id', label: 'ID'},
          {key: 'Name', label: 'Name'},
          {key: 'action', label: 'Action'}
        ],
        listGiftsFields: [
          {key: 'Id', label: 'ID'},
          {key: 'GiftId', label: 'Gift Id'},
          {key: 'Name', label: 'Name'},
          {key: 'Quantity', label: 'Qty'},
          {key: 'Occurrence', label: 'Occurrence', thStyle: { width: '120px' }},
          {key: 'DisplayOrder', label: 'Display Order', thStyle: { width: '120px' }}
          // {key: 'action', label: 'Action'}
        ],
        currentPage: 1,
        giftsCurrentPage: 1,
        perPage: 10,
        giftsPerPage: 5,
        removeId: '',
        giftId: '',
        giftOccurrence: 0,
        giftDisplayOrder: 0,
        cGiftListName: '',
        selectedGiftListId: '',
        updateId: '',
        cOccurrence: '',
        cDisplayOrder: ''
      }
    },
    validations: {
      giftId: { required },
      giftOccurrence: { required, numeric, minValue: minValue(0), maxValue: maxValue(9999999) },
      giftDisplayOrder: { required, numeric, minValue: minValue(0), maxValue: maxValue(9999999) },
      cGiftListName: { required, minLength: minLength(2), maxLength: maxLength(50) },
      cOccurrence: { required, numeric, minValue: minValue(0), maxValue: maxValue(9999999) },
      cDisplayOrder: { required, numeric, minValue: minValue(0), maxValue: maxValue(9999999) }
    },
    watch: {
      currentPage: function () {
        this.getGiftList()
      },
      giftsCurrentPage: function () {
        this.getListGifts()
      }
    },
    methods: {
      getRowCount (items) {
        return items.length
      },
      getGiftLists () {
        this.$http.get(this.API_ENDPOINT + '/luckywheel/gift/list/all', {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.items = response.data.list
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      getListGifts () {
        this.$http.post(this.API_ENDPOINT + '/luckywheel/gift/list/mapping', { 'id': this.selectedGiftListId }, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.listGifts = response.data.gifts
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      getAllGifts () {
        this.$http.get(this.API_ENDPOINT + '/luckywheel/gift/all?status=1', {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.gifts = response.data.gifts
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      createGiftList () {
        this.$http.post(this.API_ENDPOINT + '/luckywheel/gift/list/create', { 'name': this.cGiftListName }, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          if (response.status === 200) {
            this.getGiftLists()
            this.hideCreateModal()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Gift List Created')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      addGift () {
        this.$http.post(this.API_ENDPOINT + '/luckywheel/gift/list/add', {'listId': this.selectedGiftListId, 'giftId': this.giftId, 'occurrence': this.giftOccurrence, 'displayOrder': this.giftDisplayOrder}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          if (response.status === 200) {
            this.getListGifts()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Gift Added')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      removeGift () {
        this.$http.post(this.API_ENDPOINT + '/luckywheel/gift/list/remove', {'id': this.removeId}, {headers: { 'Content-Type': 'application/json' }}).then(response => {
          if (response.status === 200) {
            this.getListGifts()
            this.cancelRemove()
            Events.$emit('alert', VueNotifications.types.success, 'Success', 'Gift Removed From List')
          }
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      },
      showUpdateGiftList (item) {
        this.updateId = item.Id
        this.cOccurrence = item.Occurrence
        this.cDisplayOrder = item.DisplayOrder
        this.$set(item, '_showUpdate', true)
      },
      cancelUpdateGiftList (item) {
        this.$delete(item, '_showUpdate')
        this.updateId = ''
        this.cOccurrence = ''
        this.cDisplayOrder = ''
      },
      async updateGiftList (item) {
        try {
          Events.$emit('loader')
          await this.$http.post(this.API_ENDPOINT + '/luckywheel/gift/list/update', {
            id: this.updateId,
            occurrence: this.cOccurrence,
            order: this.cDisplayOrder
          }, { headers: { 'Content-Type': 'application/json' } })
          this.getListGifts()
          this.cancelUpdateGiftList(item)
        } catch (err) {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        } finally {
          Events.$emit('loader')
        }
      },
      confirmRemoveGift (id) {
        this.removeId = id
        this.$refs.confirm.show()
      },
      cancelRemove () {
        this.$refs.confirm.hide()
        this.showEditModal(this.selectedGiftListId)
      },
      showCreateModal () {
        this.reset()
        this.$refs.createGifList.show()
      },
      showEditModal (id) {
        this.selectedGiftListId = id
        this.reset()
        this.getListGifts()
        this.$refs.editGifList.show()
      },
      hideCreateModal () {
        this.$refs.createGifList.hide()
      },
      hideEditModal () {
        this.$refs.editGifList.hide()
      },
      reset () {
        this.giftId = ''
        this.giftOccurrence = 0
        this.giftDisplayOrder = 0
        this.cGiftListName = ''
      }
    },
    created () {
      this.getAllGifts()
      this.getGiftLists()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/luckywheel/giftlist/GiftListTable.vue